export const getUserIP = async (): Promise<string> => {
  const endpoints = [
    'https://api.ipify.org?format=json',
    'https://api64.ipify.org?format=json',
    'https://v4.ident.me/json'
  ];

  for (const endpoint of endpoints) {
    try {
      const response = await fetch(endpoint);
      const json = await response.json();
      return json.ip;
    }
    catch (error) {}
  }

  return '0.0.0.0';
};
